import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import CalculatorContainer from './CalculatorContainer';
import ComparisonContainer from './ComparisonContainer';
import ShareModal from './ShareModal';
import { Back, Compare, Share } from './ui';

const dummyData = {
    carModel: '718 Cayman',
    inStock: 34,
    startingPrice: '278,788',
    imgSrc: 'https://afc-next.s3.amazonaws.com/variant/image/61de9cdfba9de6001c461c05.png',
    coe: '60,005',
    totalPrice: '341,993',
    financialInstitution: 'Hong Leong Finance',
    financialProduct: 'Standard Hire Purchase',
    interestRate: '2.28% p.a. flat',
    downPayment: '136,798 (60%)',
    tenure: 72,
    loanAmount: '205,195 (60%)',
    monthlyPayment: 3240,
    promoCode: 'CODE1',
};

const config = [
    {
        editable: false,
        size: 1,
        key: 'coe',
    },
    {
        editable: false,
        size: 1,
        key: 'totalPrice',
    },
    {
        editable: true,
        size: 1,
        key: 'financialInstitution',
    },
    {
        editable: true,
        size: 1,
        key: 'financialProduct',
    },
    {
        editable: true,
        size: 1,
        key: 'interestRate',
    },
    {
        editable: true,
        size: 1,
        key: 'downPayment',
    },
    {
        editable: true,
        size: 1,
        key: 'tenure',
    },
    {
        editable: true,
        size: 1,
        key: 'loanAmount',
    },
    {
        editable: false,
        size: 2,
        key: 'monthlyPayment',
    },
    {
        editable: false,
        size: 2,
        key: 'promoCode',
    },
];

/**
 *
 * ? should this component be refactored with context API ?
 */

export interface CompareCalculator {
    id: number;
    dataSource: any;
}

const Calculator = () => {
    const { t } = useTranslation(['calculation']);
    const [openShare, setOpenShare] = useState(false);
    const [calculators, setCalculators] = useState<CompareCalculator[]>([{ id: 1, dataSource: dummyData }]);

    const compare = useCallback(() => {
        if (calculators.length >= 3) {
            return;
        }
        setCalculators(prevState => {
            const newId = calculators[calculators.length - 1].id + 1;
            const newObj = { id: newId, dataSource: { ...dummyData } };
            const newState = prevState.map(obj => ({ ...obj }));
            newState.push(newObj);

            return newState;
        });
    }, [calculators, setCalculators]);

    const extra = useMemo(
        () => (
            <>
                <Compare onClick={compare} text={t('calculation:actions.compare')} />
                <Share onClick={() => setOpenShare(true)} text={t('calculation:actions.share')} />
            </>
        ),
        [compare, setOpenShare, t]
    );

    return (
        <ConsolePageWithHeader
            backIcon={<Back onClick={() => undefined} text={t('calculation:labels.models')} />}
            extra={extra}
            ghost={false}
            onBack={() => null}
            title={false}
        >
            {calculators.length > 1 ? (
                <ComparisonContainer calculators={calculators} setCalculators={setCalculators} />
            ) : (
                <CalculatorContainer config={config} dataSource={dummyData} />
            )}

            <ShareModal openShare={openShare} setOpenShare={setOpenShare} />
        </ConsolePageWithHeader>
    );
};

export default Calculator;
